import ImageWithDisplayName from "@/common/components/ImageWithDisplayName"
import { User2Icon } from "lucide-react"
import { branchHierarchyForUserAccess } from "../constants/branchHierarchyForUserAccess.constant"
import { ClientUserBranchAccess } from "../types/clientUserBranchAccess.type"
import CompanyBranchUserAccessesDelete from "../components/show/CompanyBranchUserAccesses/CompanyBranchUserAccessesDelete"
import CompanyBranchUserAccessesUpdate from "../components/show/CompanyBranchUserAccesses/CompanyBranchUserAccessesUpdate"

export class ClientUserBranchAccessesTransformer {

  static tableTransformer() {
    return (userBranchAccesses: ClientUserBranchAccess[]) => {
      return userBranchAccesses.map(userBranchAccess => {
        return {
          user: (
            <ImageWithDisplayName
              placeholderIcon={User2Icon}
              imageUrl={userBranchAccess.user.profile_picture.url}
              displayName={userBranchAccess.user.full_name}
            />
          ),
          branch: userBranchAccess.branch.display_name,
          branch_hierarchy_for_user_access: branchHierarchyForUserAccess[userBranchAccess.branch_hierarchy_for_user_access || 'same_only'],
          actions: (
            <div className="flex items-center justify-center gap-3">
              <CompanyBranchUserAccessesDelete userBranchAccess={userBranchAccess} />

              <CompanyBranchUserAccessesUpdate userBranchAccess={userBranchAccess} />
            </div>
          ),
        }
      })
    }
  }

  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      return Object.entries(errors).map(([key, value]) => {
        if (key.startsWith('user_branch_accesses.')) {
          key = key.slice(21);
        }

        if (key === 'user_id') {
          key = 'user';
        }

        return {
          [key]: value.join(', ')
        };
      });
    };
  };

}
